import { createContext, useState } from 'react';
import { toastWarning } from 'utils/toast';
import api from 'services/api';

export const IntegracaoContext = createContext();

export const IntegracaoProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [postLoading, setPostLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const getAuthURL = async ({
    params,
    integracao_id,
    integracao_api,
    cb = null,
  }) => {
    const url = {
      AMAZON: `/Integracoes/Amazon/URL/${integracao_id}`,
      'MADEIRA MADEIRA': `/Integracoes/MadeiraMadeira/URL/${integracao_id}`,
      'MAGAZINE LUIZA': `/Integracoes/Magalu/URL/${integracao_id}`,
      'MERCADO LIVRE': `/Integracoes/MercadoLivre/URL/${integracao_id}`,
      SHEIN: `/Integracoes/Shein/URL/${integracao_id}`,
      SHOPEE: `/Integracoes/Shopee/URL/${integracao_id}`,
      TIKTOK: `/Integracoes/Tiktok/URL/${integracao_id}`,
    };
    try {
      setGetLoading(true);
      if (!url[integracao_api]) {
        toastWarning('Não foi possível autenticar. URL não disponível');
        throw new Error();
      }
      const { data } = await api.get(url[integracao_api], { params });
      if (cb) {
        cb?.(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const getIntegracao = async ({ cb = null }) => {
    try {
      setGetLoading(true);
      const { data } = await api.get('/Integracoes');
      if (cb) {
        cb(data);
      }
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  const postIntegracao = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      const res = await api.post('/Integracoes', data);
      if (cb) {
        cb(res?.data);
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postIncubadoraE = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      const res = await api.post('/Integracoes/IncubadoraE', data);
      if (cb) {
        cb(res?.data);
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const postIncubadoraR = async ({ data, cb = null }) => {
    try {
      setPostLoading(true);
      const res = await api.post('/Integracoes/IncubadoraR', data);
      if (cb) {
        cb(res?.data);
      }
    } catch (error) {
    } finally {
      setPostLoading(false);
    }
  };

  const deleteIntegracao = async ({ id, cb = null }) => {
    try {
      setDeleteLoading(true);
      await api.delete(`/Integracoes/${id}`);
      if (cb) {
        cb();
      }
    } catch (error) {
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <IntegracaoContext.Provider
      value={{
        getLoading,
        postLoading,
        deleteLoading,
        getAuthURL,
        getIntegracao,
        postIntegracao,
        deleteIntegracao,
        postIncubadoraE,
        postIncubadoraR,
      }}
    >
      {children}
    </IntegracaoContext.Provider>
  );
};
